import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import $ from 'jquery';
import { userInfo, userRegister as _userRegister, myCategories, updateInfo } from '@/api/mg';
export default {
  watch: {
    '$route': function $route(to, from) {
      var isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      console.log(from.meta.index, to.meta.index, 'ppppp');
      if (to.meta.index && from.meta.index) {
        if (to.meta.index > from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        return;
      }
      if (isBack) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
    }
  },
  data: function data() {
    return {
      themeData: '',
      leftIcon: require('../../assets/images/Search.png'),
      isShowWrap: false,
      transitionName: '',
      themeArr: [],
      // arr: ['Club', 'Activity', 'Video', 'News'],
      arr: ['Community', 'Activity', 'News'],
      // activeName: localStorage.getItem('activeName') || 'Club',
      activeName: 'Community',
      searchTxt: '',
      isShowPostPop: false,
      show: true,
      // 默认显示。保证未登录时也能看到首页
      checkParams: {}
    };
  },
  created: function created() {
    var params = JSON.parse(localStorage.getItem('appParams')) || {};
    // params.uid = 1221
    console.log(params, 111111);
    this.activeName = localStorage.getItem('activeName') || 'Community';
    this.tabChange(this.activeName);
    // const checkParams = { appUserId: params.uid || localStorage.getItem('userId'), nickname: params.nickname || localStorage.getItem('nickname') }
    // const registerParams = { mobilePhone: params.mobilePhone,
    //   nickname: params.nickname || localStorage.getItem('nickname'),
    //   avatar: params.avatar,
    //   uuid: params.uid,
    //   isOwner: params.isOwner || localStorage.getItem('isOwner') }

    // 获取导航栏tabs
    this.getMyCategories();

    // if (localStorage.getItem('socialToken')) {
    //   // this.getThreadList(threadListParams)
    //   this.getMyCategories()
    //   this.show = true
    //   return
    // }

    // userCheck(checkParams).then((res) => {
    //   if (res.Code === 0) {
    //     localStorage.setItem('socialToken', res.Data.accessToken)
    //     this.$store.state.socialToken = res.Data.accessToken
    //     this.getUserInfo({ pid: res.Data.uid })
    //   } else {
    // this.$dialog.confirm({
    //   title: 'Confirm authorization?',
    //   confirmButtonText: 'yes',
    //   cancelButtonText: 'no'
    //   // message: '弹窗内容'
    // })
    //   .then(() => {

    // this.userRegister(registerParams)

    // })
    // .catch(() => {
    //   this.nativeBack()
    // })
    // }
    // })
  },
  mounted: function mounted() {
    var params = JSON.parse(localStorage.getItem('appParams')) || {};
    console.log(params, 99999);
    updateInfo({
      nickname: params.nickname,
      avatar: params.userPhotoBase64,
      mobilePhone: params.mobilePhone
    }).then();
    var that = this;
    this.$nextTick(function () {
      $('.wrap').on('click', function () {
        that.isShowPostPop = false;
        that.isShowWrap = false;
      });
      // $(this.$refs.tabs.$el).innerHeight($(window).height() - $('.search').innerHeight() - getPx(102) - $('.van-tabs__wrap').innerHeight())
      // $(this.$refs.tabs.$el).height($(window).height() - $('.search').innerHeight() - $('.van-tabs__wrap').height())
    });
  },
  beforeDestroy: function beforeDestroy() {
    // $(window).off('click')
  },
  methods: {
    nativeBack: function nativeBack() {
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        window.Android.back();
      } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
        this.$bridge.callhandler('back', null, function (response) {
          this.$toast(response + 'ios');
        });
      }
    },
    getMyCategories: function getMyCategories(params) {
      var _this = this;
      myCategories(params).then(function (res) {
        if (res.Code === 0) {
          _this.themeArr = [].concat(_toConsumableArray(_this.arr), _toConsumableArray(res.Data.category));
          var flag = _this.themeArr.every(function (item, index) {
            return item !== localStorage.getItem('activeName');
          });
          if (flag) {
            _this.activeName = 'Community';
            _this.tabChange('Community');
          }
          console.log(_this.themeArr, 'this.themeArr');
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    getUserInfo: function getUserInfo(params) {
      var _this2 = this;
      userInfo(params).then(function (res) {
        if (res.Code === 0) {
          localStorage.setItem('userId', res.Data.id);
          localStorage.setItem('pid', res.Data.group.pid);
          _this2.show = true;
          _this2.getMyCategories();
          // this.getThreadList(threadListParams)
        } else {
          // this.$toast(res.Message)
        }
      });
    },
    userRegister: function userRegister(params) {
      var _this3 = this;
      _userRegister(params).then(function (res) {
        if (res.Code === 0) {
          localStorage.setItem('socialToken', res.Data.accessToken);
          _this3.$store.state.socialToken = res.Data.accessToken;
          _this3.getUserInfo({
            pid: res.Data.uid
          });
        } else {
          // this.$toast(res.Message)
        }
      });
    },
    showPostPop: function showPostPop() {
      this.isShowPostPop = true;
      this.isShowWrap = true;
    },
    toChoose: function toChoose() {
      this.$router.push({
        path: '/social/choose'
      });
    },
    toScan: function toScan() {
      this.$toast('开发中...');
    },
    toPostArticle: function toPostArticle() {
      this.$toast('开发中...');
      // this.$router.push({ path: '/social/postArticle' })
    },
    toMsg: function toMsg() {
      this.$router.push({
        path: '/message'
      });
    },
    toPost: function toPost() {
      // const token = JSON.parse(localStorage.getItem('appParams')).token
      // // 判断未登录
      // if (token == '') {
      //   var u = navigator.userAgent
      //   if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
      //     window.Android.unLogin()
      //   } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
      //     this.$bridge.callhandler('unLogin', null, function (response) { })
      //   }
      // } else {
      //   this.$router.push({ path: '/social/post' })
      // }
      this.$router.push({
        path: '/social/post'
      });
    },
    toSearch: function toSearch() {
      var token = JSON.parse(localStorage.getItem('appParams')).token;
      // 判断未登录
      if (token == '') {
        var u = navigator.userAgent;
        if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
          window.Android.unLogin();
        } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
          this.$bridge.callhandler('unLogin', null, function (response) {});
        }
      } else {
        this.$router.push({
          path: '/social/search'
        });
      }
    },
    tabChange: function tabChange(name, title) {
      if (name == 'Community') {
        name = 'Club';
      }
      // this.themeData = ''
      // const index = this.themeArr.indexOf(name)
      // threadListParams['filter[categoryids][0]'] = index + 1
      // this.getThreadList(threadListParams)
      var path = name.toLowerCase();
      console.log(this.$router.history.current.path, 'this.$router.path', path);
      if (this.$router.history.current.path !== "/social/".concat(path.toLowerCase())) {
        this.$router.replace({
          path: "/social/".concat(path.toLowerCase())
        });
      }
      localStorage.setItem('activeName', name);
    }
  }
};